const initialState = null;

function selectedZoneReducer(state = initialState, action) {
  switch (action.type) {
    case "selectedZone/update":
      return action.payload;
    case "selectedZone/clear":
      return null;
    default:
      return state;
  }
}

export default selectedZoneReducer;
